module.exports = __webpack_public_path__ + "img/bread-home.5ee2ea89.png";